// export default {
//   baseUrl: "rayabot.ir",
//   apiUrl: `https://${
//     process.env.REACT_APP_NODE_ENV == "dev" ? "api.dev" : "api"
//   }.rayabot.ir/v1`,
//   cdnUrl: `https://${
//     process.env.REACT_APP_NODE_ENV == "dev" ? "cdn.dev" : "cdn"
//   }.rayabot.ir/`,
//   wsUrl: process.env.REACT_APP_BASE_ASR_URL_API,
// };
// export default {
//   baseUrl: "rayabot.ir",
//   apiUrl: `https://${
//     process.env.REACT_APP_NODE_ENV == "dev" ? "api.dev" : "api"
//   }.rayabot.ir/v1`,
//   cdnUrl: `https://${
//     process.env.REACT_APP_NODE_ENV == "dev" ? "cdn" : "cdn"
//   }.rayabot.ir/`,
//   wsUrl: process.env.REACT_APP_BASE_ASR_URL_API,
// };
// const isDev =
//   process.env.REACT_APP_NODE_ENV === "dev" ||
//   window.location.hostname === "localhost";

// export default {
//   baseUrl: "rayabot.ir",
//   apiUrl: `https://${isDev ? "api" : "api"}.rayabot.ir/v1`,
//   cdnUrl: `https://${isDev ? "cdn" : "cdn"}.rayabot.ir/`,
//   wsUrl: process.env.REACT_APP_BASE_ASR_URL_API,
// };
const isDev =
  process.env.REACT_APP_NODE_ENV === "dev" ||
  window.location.hostname === "localhost";

export default {
  baseUrl: "rayabot.ir",
  apiUrl: `${process.env.REACT_APP_API_URL}`,
  cdnUrl: `${process.env.REACT_APP_CDN_URL}`,
  wsUrl: process.env.REACT_APP_BASE_ASR_URL_API,
};
// const isDev =
//   process.env.REACT_APP_NODE_ENV === "dev" ||
//   window.location.hostname === "localhost";

// export default {
//   baseUrl: "rayabot.ir",
//   apiUrl: `${process.env.REACT_APP_API_URL}/v1`,
//   cdnUrl: `${process.env.REACT_APP_CDN_URL}`,
//   wsUrl: process.env.REACT_APP_BASE_ASR_URL_API,
// };
